import { defineMessages } from 'react-intl';

export default defineMessages({
  userModalAddAdmin: {
    defaultMessage: 'Create new company admin',
    description: 'User modal - add new admin',
    id: 'userModal.add.admin',
  },
  userModalAddAdminUserCategoryHelperText: {
    defaultMessage: 'This helps us better understand our users’ needs',
    id: 'userModal.add.admin.userCategory.helperText',
  },
  userModalAddAdminUserCategoryLabel: {
    defaultMessage: 'Role in the building',
    id: 'userModal.add.admin.userCategory.label',
  },
  userModalAddAdminUserCategoryOtherLabel: {
    defaultMessage: 'Please specify your role',
    id: 'userModal.add.admin.userCategory.other.label',
  },
  userModalAddAdminUserCategoryPlaceholder: {
    defaultMessage: 'Select your role',
    id: 'userModal.add.admin.userCategory.placeholder',
  },
  userModalAddSiteUser: {
    defaultMessage: 'Create new site user',
    description: 'User modal - add new site user',
    id: 'userModal.add.siteUser',
  },
  userModalAddSiteUserUserCategoryHelperText: {
    defaultMessage: 'Help us better understand our users’ needs',
    id: 'userModal.add.siteUser.userCategory.helperText',
  },
  userModalAddSiteUserUserCategoryLabel: {
    defaultMessage: 'Role in the building',
    id: 'userModal.add.siteUser.userCategory.label',
  },
  userModalAddSiteUserUserCategoryOtherLabel: {
    defaultMessage: 'Please specify your role',
    id: 'userModal.add.siteUser.userCategory.other.label',
  },
  userModalAddSiteUserUserCategoryPlaceholder: {
    defaultMessage: 'Select your role',
    id: 'userModal.add.siteUser.userCategory.placeholder',
  },
  userModalEditAdmin: {
    defaultMessage: 'Edit company admin',
    description: 'User modal - edit admin',
    id: 'userModal.edit.admin',
  },
  userModalEditProfile: {
    defaultMessage: 'Edit user profile',
    description: 'User modal - edit profile',
    id: 'userModal.edit.profile',
  },
  userModalEditSiteUser: {
    defaultMessage: 'Edit user profile',
    description: 'User modal - edit site user',
    id: 'userModal.edit.siteUser',
  },
  userModalEmailExistAdmin: {
    defaultMessage: 'Admin with this e-mail address already exists in this Company.',
    description: 'User modal - admin email exists',
    id: 'userModal.email.exist.admin',
  },
  userModalEmailExistUser: {
    defaultMessage: 'User with this e-mail address already exists in this Site.',
    description: 'User modal - user email exists',
    id: 'userModal.email.exist.user',
  },
  userModalEmailValid: {
    defaultMessage: 'Wrong format of the e-mail.',
    description: 'User modal - email is not valid',
    id: 'userModal.email.valid',
  },
  userModalFormActionsAdd: {
    defaultMessage: 'Add',
    description: 'User modal - add submit button',
    id: 'userModal.formActions.add',
  },
  userModalFormActionsCancel: {
    defaultMessage: 'Cancel',
    description: 'User modal - cancel button',
    id: 'userModal.formActions.cancel',
  },
  userModalFormActionsCreateCompanyAdmin: {
    defaultMessage: 'Create admin',
    description: 'User modal - create company admin submit button',
    id: 'userModal.formActions.createCompanyAdmin',
  },
  userModalFormActionsCreateSiteUser: {
    defaultMessage: 'Create user',
    description: 'User modal - create site user submit button',
    id: 'userModal.formActions.createSiteUser',
  },
  userModalFormActionsSave: {
    defaultMessage: 'Save changes',
    description: 'User modal - edit submit button',
    id: 'userModal.formActions.save',
  },
  userModalLabelEmail: {
    defaultMessage: 'User e-mail',
    description: 'User modal - email label',
    id: 'userModal.label.email',
  },
  userModalLabelFirstName: {
    defaultMessage: 'First name',
    description: 'User modal - first name label',
    id: 'userModal.label.firstName',
  },
  userModalLabelLastName: {
    defaultMessage: 'Surname',
    description: 'User modal - last name label',
    id: 'userModal.label.lastName',
  },
  userModalLabelNewsletters: {
    defaultMessage: 'I agree to receive occasional newsletters',
    description: 'User modal - newsletters label',
    id: 'userModal.label.newsletters',
  },
  userModalMaxLength: {
    defaultMessage: 'Name is too long.',
    description: 'User modal - maxLength value',
    id: 'userModal.maxLength',
  },
  userModalRequired: {
    defaultMessage: 'Value is mandatory',
    description: 'User modal - required value',
    id: 'userModal.required',
  },
  usersFormAllowCallingLabel: {
    defaultMessage: 'Allow to call this number via the intercom display when calling this user',
    description: 'User modal - allow calling label',
    id: 'usersForm.allowCalling.label',
  },
  usersFormAllowCallingTooltip: {
    defaultMessage: 'For proper funcionality SIP profiles need to be set in Remote configuration for each device.',
    description: 'User modal - allow calling tooltip',
    id: 'usersForm.allowCalling.tooltip',
  },
  usersFormAllowCallingWarning: {
    defaultMessage: `To be able to call this user, make sure to enter their apartment. Without it, the number can't be added to the intercom button.`,
    description: 'User modal - allow calling warning',
    id: 'usersForm.allowCalling.warning',
  },
  usersFormMobilePhoneErrFormat: {
    defaultMessage: 'Use the correct format (6–15 digits)',
    description: 'User modal - mobile phone error message',
    id: 'personalInfo.mobilePhone.errFormat',
  },
  usersFormMobilePhoneHelperText: {
    defaultMessage: 'Use international format of the number',
    description: 'User modal - mobile phone helper text',
    id: 'usersForm.mobilePhone.helperText',
  },
  usersFormMobilePhoneLabel: {
    defaultMessage: 'Mobile phone',
    description: 'User modal - mobile phone label',
    id: 'usersForm.mobilePhone.label',
  },
  usersFormMobilePhonePlaceholder: {
    defaultMessage: '+14155552671 ',
    description: 'User modal - mobile phone helper text',
    id: 'usersForm.mobilePhone.placeholder',
  },
});
